<template>
    <v-flex>
    <div class="mt-3 ml-3">
				<v-flex >
					<v-btn @click="$emit('changeConfig',0)"> konfiguruj dla oferty </v-btn>
					<v-btn > konfiguruj osobno dla każdego modułu </v-btn>
					<v-btn @click="$emit('changeConfig',2)"> relacje między modułami </v-btn>
				</v-flex>
				<v-flex style="margin: 8px;">
				<v-tooltip bottom max-width="480px">
							<template v-slot:activator="{ on }">
								{{ informationShort }}
								<v-icon color="primary" dark v-on="on">info</v-icon>
							</template>
							<span>
								{{ information }}
							</span>
						</v-tooltip>
				</v-flex>
				<v-flex>
					<v-btn @click="fullSave" primary>Zapisz</v-btn>
				</v-flex>
			</div>
<v-card-text>
    <v-tabs color="blue" v-model="tab">

        <v-tab v-for="(module, index) in modulesData" :key="index" @click="actualModuleNumberIndex = (index)">moduł {{ module.moduleNumber }}</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="(module, indexInTab) in modulesData"
        :key="indexInTab"
        :value="indexInTab"
      >
      <egranty-switch 
							:disabled="contestData.announced"
							v-model="modulesData[indexInTab].extendFinancialSettings"
							aria-label="Konfiguruj osobno dla modułu"
							:title="modulesData[indexInTab].extendFinancialSettings ? 'Limity finansowe dla modułu są określane odrębnie' : 'Limity finansowe dla modułu są zgodne z limitami finansowymi dla oferty'"
						></egranty-switch>

        <v-container v-if="modulesData[indexInTab].extendFinancialSettings">
				<v-container fluid>
					<v-layout mb-3 ml-3>
						<h3>Limity dofinansowania</h3>
					</v-layout>
					<v-layout ml-3>
						<v-expand-transition>
							<v-flex xs4 v-show="!modulesData[indexInTab].financialSettings.fundingPerCountry">
								<egranty-number-input-field
									v-model="modulesData[indexInTab].financialSettings.minFunding"
									label="Minimalna kwota dofinansowania"
									for="contest-financial-settings-view-min-funding"
									id="contest-financial-settings-view-min-funding"
									suffix=" PLN"
									placeholder="np. 50000"
								></egranty-number-input-field>
								<egranty-number-input-field
									v-model="modulesData[indexInTab].financialSettings.maxFunding"
									label="Maksymalna kwota dofinansowania"
									for="contest-financial-settings-view-max-funding"
									id="contest-financial-settings-view-max-funding"
									suffix=" PLN"
									placeholder="np. 5000000"
								></egranty-number-input-field>
							</v-flex>
						</v-expand-transition>
					</v-layout>

					<v-layout>
						<egranty-switch
							:disabled="contestData.announced"
							v-model="modulesData[indexInTab].financialSettings.fundingPerCountry"
							aria-label="funding per country enabled"
							title="Limity dofinansowania inne na każdy kraj"
							@input="(value) => perCountrySwitchHandler(value, indexInTab)"
						></egranty-switch>
					</v-layout>
					<v-layout>
						<v-expand-transition>
							<v-flex v-if="modulesData[indexInTab].financialSettings.fundingPerCountry">
								<egranty-switch
									aria-label="funding per legal form per country enabled"
									:disabled="contestData.announced"
									v-model="modulesData[indexInTab].financialSettings.fundingPerLegalFormPerCountry"
									title="Dodatkowo inne na każdą formę prawną"
								></egranty-switch>

								<v-expand-transition>
									<v-layout v-if="!modulesData[indexInTab].financialSettings.fundingPerLegalFormPerCountry">
										<v-flex>
											<financial-limits-per-country
												ref="financialLimitsPerCountry"
												@error="openFinancialLimitErrorPopup"
                                                :module-number = (indexInTab+1)
											></financial-limits-per-country>
										</v-flex>
									</v-layout>
								</v-expand-transition>

								<v-expand-transition>
									<v-layout v-if="modulesData[indexInTab].financialSettings.fundingPerLegalFormPerCountry">
										<v-flex>
											<financial-limits-per-legal-form
												ref="financialLimitsPerLegalForm"
												:legal-forms="legalForms"
												:module-number = (indexInTab+1)
												@error="openFinancialLimitErrorPopup"
											></financial-limits-per-legal-form>
										</v-flex>
									</v-layout>
								</v-expand-transition>
							</v-flex>
						</v-expand-transition>
					</v-layout>


					<v-flex my-4>
						<v-divider/>
					</v-flex>
					<v-layout ma-3>
						<v-flex>
							<h3>Minimalny poziom wkładu własnego</h3>
						</v-flex>
					</v-layout>
					<v-layout row>

						<v-flex xs4 ml-3>
							<v-subheader> {{ modulesData[indexInTab].financialSettings.minOwnContributionRefersToWholeCosts === true ?
								"Wartość wkładu odnosi się do całkowitego kosztu realizacji zadania" :
								"Wartość wkładu odnosi się do wnioskowanej dotacji" }}
							</v-subheader>
						</v-flex>
						<v-flex xs12 sm3>
							<v-btn flat icon color="green" @click="changeMinContributionReferral(indexInTab)">
								<v-icon>cached</v-icon>
							</v-btn>
						</v-flex>
					</v-layout>
					<egranty-switch
						:disabled="contestData.announced"
						v-model="modulesData[indexInTab].financialSettings.minOwnContributionPerLegalForm"
						aria-label="minimum own contribution per legal form enabled"
						title="Inna wartość dla każdej formy prawnej"
						@input="minOwnContributionPerLegalFormHandler(indexInTab)"
					></egranty-switch>

					<v-expand-transition>
						<v-layout v-show="modulesData[indexInTab].financialSettings.minOwnContributionPerLegalForm" class="ml-3">
							<v-flex xs6>
								<v-data-table
									:items="modulesData[indexInTab].moduleLegalFormFinancialLimitList"
									:headers="tableHeaders"
									class="elevation-1"
									hide-actions>
									<template slot="items" slot-scope="props">
										<td>{{ props.item.legalForm.name }}</td>
										<td>{{ formatMoney(props.item.minOwnContributionSize) }}</td>
										<td>
											<v-icon
												small
												class="mr-2"
												@click="editLegalFormMinOwnContributionSize(props.item)">
												edit
											</v-icon>
										</td>
									</template>
								</v-data-table>
							</v-flex>
						</v-layout>
					</v-expand-transition>

					<v-expand-transition>
						<v-layout v-show="!modulesData[indexInTab].financialSettings.minOwnContributionPerLegalForm" class="ml-3">
							<v-flex xs1>
								<egranty-number-input-field
									v-model="modulesData[indexInTab].financialSettings.minOwnContributionSize"
									suffix="%"
									placeholder="np. 25"
								></egranty-number-input-field>
							</v-flex>
						</v-layout>
					</v-expand-transition>

					<v-flex my-4>
						<v-divider/>
					</v-flex>
					<v-layout ma-3>
						<v-flex>
							<h3>Maksymalny poziom wkładu własnego</h3>
						</v-flex>
					</v-layout>
					<v-layout row>

						<v-flex xs4 ml-3>
							<v-subheader> {{ modulesData[indexInTab].financialSettings.maxOwnContributionRefersToWholeCosts === true ?
								"Wartość wkładu odnosi się do całkowitego kosztu realizacji zadania" :
								"Wartość wkładu odnosi się do wnioskowanej dotacji" }}
							</v-subheader>
						</v-flex>
						<v-flex xs12 sm3>
							<v-btn flat icon color="green" @click="changeMaxContributionReferral(indexInTab)">
								<v-icon>cached</v-icon>
							</v-btn>
						</v-flex>
					</v-layout>
					<egranty-switch
						:disabled="contestData.announced"
						v-model="modulesData[indexInTab].financialSettings.maxOwnContributionPerLegalForm"
						aria-label="maximum own contribution per legal form enabled"
						title="Inna wartość dla każdej formy prawnej"
						@input="maxOwnContributionPerLegalFormHandler(indexInTab)"
					></egranty-switch>

					<v-expand-transition>
						<v-layout v-show="modulesData[indexInTab].financialSettings.maxOwnContributionPerLegalForm" class="ml-3">
							<v-flex xs6>
								<v-data-table
									:items="modulesData[indexInTab].moduleLegalFormFinancialLimitList"
									:headers="tableHeaders"
									class="elevation-1"
									hide-actions>
									<template slot="items" slot-scope="props">
										<td>{{ props.item.legalForm.name }}</td>
										<td>{{ formatMoney(props.item.maxOwnContributionSize) }}</td>
										<td>
											<v-icon
												small
												class="mr-2"
												@click="editLegalFormMaxOwnContributionSize(props.item)">
												edit
											</v-icon>
										</td>
									</template>
								</v-data-table>
							</v-flex>
						</v-layout>
					</v-expand-transition>

					<v-expand-transition>
						<v-layout v-show="!modulesData[indexInTab].financialSettings.maxOwnContributionPerLegalForm" class="ml-3">
							<v-flex xs1>
								<egranty-number-input-field
									v-model="modulesData[indexInTab].financialSettings.maxOwnContributionSize"
									suffix="%"
									placeholder="np. 25"
								></egranty-number-input-field>
							</v-flex>
						</v-layout>
					</v-expand-transition>

					<v-layout my-3>
						<v-divider></v-divider>
					</v-layout>

					<v-layout ma-3>
						<v-flex>
							<h3>Dopuszczalna wysokość kosztów administracyjnych</h3>
						</v-flex>
					</v-layout>

					<v-layout row>
						<v-flex xs4 ml-3>
							<v-subheader> {{ modulesData[indexInTab].financialSettings.administrativeExpensesReferToWholeCosts ===
								true ?
									"Wysokość kosztów odnosi się do całkowitego kosztu realizacji zadania" :
									"Wysokość kosztów odnosi się do wnioskowanej dotacji" }}
							</v-subheader>
						</v-flex>
						<v-flex xs12 sm3>
							<v-btn flat icon color="green" @click="changeAdministrativeExpensesReferral(indexInTab)">
								<v-icon>cached</v-icon>
							</v-btn>
						</v-flex>
					</v-layout>
					<egranty-switch
						:disabled="contestData.announced"
						v-model="modulesData[indexInTab].financialSettings.administrativeExpensesPerLegalForm"
						aria-label="administrative expenses per legal form enabled"
						title="Inna wysokość dla każdej formy prawnej"
						@input="administrativeExpensesHandler(indexInTab)"
					></egranty-switch>

					<v-expand-transition>
						<v-layout v-show="modulesData[indexInTab].financialSettings.administrativeExpensesPerLegalForm" class="ml-3">
							<v-flex xs6>
								<v-data-table
									:items="modulesData[indexInTab].moduleLegalFormFinancialLimitList"
									:headers="secondTableHeaders"
									class="elevation-1"
									hide-actions>
									<template slot="items" slot-scope="props">
										<td>{{ props.item.legalForm.name }}</td>
										<td>{{ formatMoney(props.item.administrativeExpensesSize) }}</td>
										<td>
											<v-icon
												small
												class="mr-2"
												@click="editLegalFormAdministrativeExpensesSize(props.item)">
												edit
											</v-icon>
										</td>
									</template>
								</v-data-table>
							</v-flex>
						</v-layout>
					</v-expand-transition>

					<v-expand-transition>
						<v-layout v-show="!modulesData[indexInTab].financialSettings.administrativeExpensesPerLegalForm" class="ml-3">
							<v-flex xs1>
								<egranty-number-input-field
									v-model="modulesData[indexInTab].financialSettings.administrativeExpensesSize"
									suffix="%"
									placeholder="np. 50"
								></egranty-number-input-field>
							</v-flex>
						</v-layout>
					</v-expand-transition>

				</v-container>
            </v-container>
      </v-tab-item>
    </v-tabs-items>
	<egranty-input-field-popup
					:default-value="editedItem.minOwnContributionSize"
					:is-open.sync="editLegalFormMinOwnContributionSizeDialog"
					:title="'Edytuj wartość wkładu'"
					:label="'Wartość wkładu (%)'"
					field-type="NUMBER"
					suffix="%"
					placeholder="np. 50"
					@save="minOwnContributionSizeChanged"
				></egranty-input-field-popup>

				<egranty-input-field-popup
					:default-value="editedItem.maxOwnContributionSize"
					:is-open.sync="editLegalFormMaxOwnContributionSizeDialog"
					:title="'Edytuj wartość wkładu'"
					:label="'Wartość wkładu (%)'"
					field-type="NUMBER"
					suffix="%"
					placeholder="np. 50"
					@save="maxOwnContributionSizeChanged"
				></egranty-input-field-popup>

				<egranty-input-field-popup
					:default-value="editedItem.administrativeExpensesSize"
					:is-open.sync="editLegalFormAdministrativeExpensesSizeDialog"
					:title="'Edytuj wysokość kosztów'"
					:label="'Wysokość kosztów (%)'"
					field-type="NUMBER"
					suffix="%"
					placeholder="np. 50"
					@save="administrativeExpensesSizeChanged"
				></egranty-input-field-popup>

				<egranty-error-list-popup
					title="Nie udało się zapisać zmian:"
					:error-list="financialLimitError.messages"
					:is-open="financialLimitError.showPopup"
					@close="closeFinancialLimitErrorPopup"
				/>
        <v-flex my-4>
						<v-divider/>
        </v-flex>
            
			</v-card-text>
        </v-flex>
</template>


<script>
	import FinancialLimitsPerCountry from "../components/FinancialLimitsPerCountry";
	import egrantySwitch from "../../../../genericComponents/EgrantySwitch";
	import egrantyNumberInputField from "../../../../genericComponents/EgrantyNumberInputField";
	import {FinancialSettings} from "@/api/generated/FinancialSettings";
	import {PublicContest} from "@/api/generated/PublicContest";
	import egrantyInputFieldPopup from "../../../../genericComponents/EgrantyInputFieldPopup";
	import FinancialLimitsPerLegalForm from "../components/FinancialLimitsPerLegalForm";
	import EgrantyErrorListPopup from "../../../../genericComponents/EgrantyErrorListPopup";
	import {Numbers} from "@/utils/Numbers";

	export default {
		name: "ContestFinancialSettingsConfigForModule",
		components: {
			EgrantyErrorListPopup,
			FinancialLimitsPerCountry,
			FinancialLimitsPerLegalForm,
			egrantySwitch,
			egrantyNumberInputField,
			egrantyInputFieldPopup,
		},
		mixins: [Numbers],

		beforeMount() {
			this.update();
		},

		mounted() {
			PublicContest.getContestLegalForms(this, this.$route.params.id, response => {
				this.legalForms = response;
				this.removeEmptyTableLoading();
			});
		},

		props: {
			information: {type: String, default:""},
			informationShort: {type: String, default:""},
		},

		data() {
			return {
                modulesData: [],
                actualModuleNumberIndex: 0,
				contestData: {
					id: this.$route.params.id,
					announced: undefined,
				},

				legalForms: [],

				tableHeaders: [
					{text: "Forma prawna", sortable: false},
					{text: "Wartość wkładu (%)", sortable: false},
					{text: "Akcje", sortable: false},
				],
				secondTableHeaders: [
					{text: "Forma prawna", sortable: false},
					{text: "Wysokość kosztów (%)", sortable: false},
					{text: "Akcje", sortable: false},
				],

				financialLimitError: {
					showPopup: false,
					messages: [],
				},

				editedItem: {},

				editLegalFormMinOwnContributionSizeDialog: false,

				editLegalFormMaxOwnContributionSizeDialog: false,

				editLegalFormAdministrativeExpensesSizeDialog: false,

                tab: null,

			};
		},
		methods: {
			perCountrySwitchHandler(val,moduleIndex) {
                if (val == false){
					this.modulesData[moduleIndex].financialSettings.fundingPerLegalFormPerCountry = false;
				}
            },
			changeMinContributionReferral(moduleIndex) {
				this.modulesData[moduleIndex].financialSettings.minOwnContributionRefersToWholeCosts = 
				!this.modulesData[moduleIndex].financialSettings.minOwnContributionRefersToWholeCosts;
			},

			changeMaxContributionReferral(moduleIndex) {
				this.modulesData[moduleIndex].financialSettings.maxOwnContributionRefersToWholeCosts = 
				!this.modulesData[moduleIndex].financialSettings.maxOwnContributionRefersToWholeCosts;
			},

			changeAdministrativeExpensesReferral(moduleIndex) {
				this.modulesData[moduleIndex].financialSettings.administrativeExpensesReferToWholeCosts = 
				!this.modulesData[moduleIndex].financialSettings.administrativeExpensesReferToWholeCosts;
			},

			editLegalFormMinOwnContributionSize(item) {
				this.editedItem = item;
				this.editLegalFormMinOwnContributionSizeDialog = true;
			},

			editLegalFormMaxOwnContributionSize(item) {
				this.editedItem = item;
				this.editLegalFormMaxOwnContributionSizeDialog = true;
			},

			minOwnContributionSizeChanged(value) {
				value = parseFloat(value);
				if (isNaN(value) || value < 0) {
					return;
				}
				this.editedItem.minOwnContributionSize = Math.round(value * 100) / 100;
				this.updateDataTable(this.editedItem);
				this.editedItem = {};
				this.editLegalFormMinOwnContributionSizeDialog = false;
			},

			maxOwnContributionSizeChanged(value) {
				value = value.replace(",", ".");
				value = parseFloat(value);
				if (isNaN(value) || value < 0) {
					return;
				}
				this.editedItem.maxOwnContributionSize = Math.round(value * 100) / 100;
				this.updateDataTable(this.editedItem);
				this.editedItem = {};
				this.editLegalFormMaxOwnContributionSizeDialog = false;
			},

			editLegalFormAdministrativeExpensesSize(item) {
				this.editedItem = item;
				this.editLegalFormAdministrativeExpensesSizeDialog = true;
			},

			administrativeExpensesSizeChanged(value) {
				value = value.replace(",", ".");
				value = parseFloat(value);
				if (isNaN(value) || value < 0) {
					return;
				}
				this.editedItem.administrativeExpensesSize = Math.round(value * 100) / 100;
				this.updateDataTable(this.editedItem);
				this.editedItem = {};
				this.editLegalFormAdministrativeExpensesSizeDialog = false;
			},

			updateDataTable(item) {
				item.contestId = this.contestData.id;
			},

			minOwnContributionPerLegalFormHandler(moduleIndex) {
				this.modulesData[moduleIndex].financialSettings.minOwnContributionSize=null;
			},

			maxOwnContributionPerLegalFormHandler(moduleIndex) {
				this.modulesData[moduleIndex].financialSettings.maxOwnContributionSize=null;
			},

			administrativeExpensesHandler(moduleIndex) {
				this.modulesData[moduleIndex].financialSettings.administrativeExpensesSize=null;
			},
			refreshLegalFormsValues(){
				PublicContest.getContestLegalForms(this, this.$route.params.id, response => {
				this.legalForms = response;
				this.removeEmptyTableLoading();
				});
			},

			fullSave() {
		let isDataInModulesValid = true;
		
		let invalidModules = this.invalidFundingValues();
        if (invalidModules && invalidModules.length>0) {
        //   this.openFinancialLimitErrorPopup(null,invalidModules);
			isDataInModulesValid = false;
        } else {
			let modulesDataCopy = JSON.parse(JSON.stringify(this.modulesData));	// deepcopy
            let postModulesData = modulesDataCopy.map(x=>{
                
				if(x.extendFinancialSettings && x.financialSettings.fundingPerCountry && !x.financialSettings.fundingPerLegalFormPerCountry){
                    let componentPerCountry = this.$refs.financialLimitsPerCountry.find(y=>x.moduleNumber == y.moduleNumber);
                    if(componentPerCountry.validate()){
                        x.singleFinancialLimitList = componentPerCountry.getValuesToSave();
                    } else {
						isDataInModulesValid = false;
                        return x;
                    }
                } else if(x.extendFinancialSettings && x.financialSettings.fundingPerCountry && x.financialSettings.fundingPerLegalFormPerCountry){
                    let componentPerLegalForm = this.$refs.financialLimitsPerLegalForm.find(y=>x.moduleNumber == y.moduleNumber);
					if (componentPerLegalForm.validate()) {
						x.singleFinancialLimitList = componentPerLegalForm.getValuesToSave();
					} else {
						isDataInModulesValid = false;
                        return x;
                    }
                }
               
				x.moduleLegalFormFinancialLimitList = x.moduleLegalFormFinancialLimitList
				.map(y => 
				{
					y.legalForm = null;
					return y;
				});


                return x;
            });
			if(!isDataInModulesValid){
				return;
			}
			FinancialSettings.postFinancialLimitsModules(this,this.$route.params.id,postModulesData, successResponse => {
					this.$messagesBus.$emit("success", "Zmiany zostały pomyślnie zapisane", successResponse);
					this.$emit('loadInfo');
				},);
			
			}
			},

			invalidFundingValues() {
				let invalidModules = [];
				let messages = [];
				this.modulesData.forEach(x=>{
					if(x.extendFinancialSettings && !x.financialSettings.fundingPerCountry){
						if (x.financialSettings.minFunding === null) {
							x.financialSettings.minFunding = 0;
						}
						if (x.financialSettings.maxFunding === "" || x.financialSettings.maxFunding === null) {
							x.financialSettings.maxFunding = null;
						}


						if(x.financialSettings.maxFunding == null || x.financialSettings.maxFunding == 0){
							messages.push("Maksymalna kwota dofinansowania nie może być równa 0 w module " + x.moduleNumber + ".");
							invalidModules.push(x.moduleNumber);
						}
						if(x.financialSettings.maxFunding !== null && (parseFloat(x.financialSettings.minFunding) > parseFloat(x.financialSettings.maxFunding))){
							messages.push("Minimalna kwota dofinansowania nie może być większa od maksymalnej w module " + x.moduleNumber + ".");
							invalidModules.push(x.moduleNumber);
						}
						if(x.financialSettings.minFunding === ""){
							messages.push("Minimalna kwota dofinansowania musi być uzupełniona w module "+ x.moduleNumber + ".");
							invalidModules.push(x.moduleNumber);
						}
						if((parseFloat(x.financialSettings.minFunding) == parseFloat(x.financialSettings.maxFunding))){
							messages.push("Minimalna i maksymalna kwota dofinansowania nie mogą być równe w module "+ x.moduleNumber + ".");
							invalidModules.push(x.moduleNumber);
						}
					}
						
						if(!x.financialSettings.minOwnContributionPerLegalForm && (x.financialSettings.minOwnContributionSize === "")){
							messages.push("Minimalny poziom wkładu własnego powinien być określony w module "+ x.moduleNumber + ".");
							invalidModules.push(x.moduleNumber);
						}
						if(!x.financialSettings.maxOwnContributionPerLegalForm && (x.financialSettings.maxOwnContributionSize === "")){
							messages.push("Maksymalny poziom wkładu własnego powinien być określony w module "+ x.moduleNumber + ".");
						invalidModules.push(x.moduleNumber);
						}
						if(!x.financialSettings.administrativeExpensesPerLegalForm && (x.financialSettings.administrativeExpensesSize === "")){
							messages.push("Dopuszczalna wysokość kosztów administracyjnych powinna być określona w module "+ x.moduleNumber + ".");
						invalidModules.push(x.moduleNumber);
						}

						//
						let minMaxMessage = "Minimalny poziom wkładu własnego powinien być mniejszy od maksymalnego poziomu wkładu własnego w module " + x.moduleNumber + ".";
						
						if(!x.financialSettings.minOwnContributionPerLegalForm && !x.financialSettings.maxOwnContributionPerLegalForm){
							if(parseFloat(x.financialSettings.maxOwnContributionSize) < parseFloat(x.financialSettings.minOwnContributionSize)){
								if(!messages.includes(minMaxMessage)){
									messages.push(minMaxMessage);
								}
								invalidModules.push(x.moduleNumber);
							}
						}
						if(x.financialSettings.minOwnContributionPerLegalForm && !x.financialSettings.maxOwnContributionPerLegalForm){
							x.moduleLegalFormFinancialLimitList.forEach(y=>{
								if(parseFloat(x.financialSettings.maxOwnContributionSize) < parseFloat(y.minOwnContributionSize)){
									if(!messages.includes(minMaxMessage)){
										messages.push(minMaxMessage);
									}
									invalidModules.push(x.moduleNumber);
								}
							});
						}
						if(x.financialSettings.maxOwnContributionPerLegalForm){
							x.moduleLegalFormFinancialLimitList.forEach(y => {
								if(y.maxOwnContributionSize === null){
									messages.push("Maksymalny poziom wkładu własnego powinien być określony dla formy prawnej " + y.legalForm.name + " w module "+ x.moduleNumber + ".");
									invalidModules.push(x.moduleNumber);
								} 
								else if(x.financialSettings.minOwnContributionPerLegalForm && (parseFloat(y.maxOwnContributionSize) < parseFloat(y.minOwnContributionSize))){
									if(!messages.includes(minMaxMessage)){
										messages.push(minMaxMessage);
									}
									invalidModules.push(x.moduleNumber);
								}
								else if(!x.financialSettings.minOwnContributionPerLegalForm && (parseFloat(y.maxOwnContributionSize) < x.financialSettings.minOwnContributionSize)){
									if(!messages.includes(minMaxMessage)){
										messages.push(minMaxMessage);
									}
									invalidModules.push(x.moduleNumber);
								}
									});
							}
						if(x.financialSettings.administrativeExpensesPerLegalForm){
							x.moduleLegalFormFinancialLimitList.forEach(y=>{
						if(y.administrativeExpensesSize === null){
							messages.push("Dopuszczalna wysokość kosztów administracyjnych powinna być określona dla formy prawnej " + y.legalForm.name + " w module "+ x.moduleNumber + ".");
							invalidModules.push(x.moduleNumber);
						}
					});
				}
					
				});
				if(invalidModules.length > 0){
					this.openFinancialLimitErrorPopup(messages);
				}
				return invalidModules;
			},

			removeEmptyTableLoading() {
				var el = document.querySelector(".v-datatable__progress");
                if(el && el.parentNode){
				el.parentNode.removeChild(el);
                }
			},

			openFinancialLimitErrorPopup(errorsMessages) {
				this.financialLimitError.messages = [];
				errorsMessages.forEach(error => {
					this.financialLimitError.messages.push(error);
				});
				this.financialLimitError.showPopup = true;
				this.$messagesBus.$emit("error", "Nie udało się zapisać zmian");
			},

			closeFinancialLimitErrorPopup() {
				this.financialLimitError.showPopup = false;
			},

			update() {

                FinancialSettings.getFinancialLimitsModules(this,this.$route.params.id,response=>{
                    this.modulesData = response;
                });

			},
		},
	};
</script>

<style scoped>

</style>